// extracted by mini-css-extract-plugin
export var productImage = "_qk-1";
export var viewLink = "_qk-2";
export var wishlistItem = "_qk-0";